import {
  AUTHORED_FONT_FAMILIES,
  isAuthoredFontFamilyId,
  type AuthoredFontFamily,
  type AuthoredFontFamilyId,
} from '../typography/fonts';

export type LabelFontFamilyId = AuthoredFontFamilyId;

export type LabelFontWeight = 'regular' | 'bold';
export type LabelFontStyle = 'normal' | 'italic';

export type LabelFontFamily = AuthoredFontFamily;

export const LABEL_FONT_FAMILIES = AUTHORED_FONT_FAMILIES;

export function isLabelFontFamilyId(value: unknown): value is LabelFontFamilyId {
  return isAuthoredFontFamilyId(value);
}

export function isLabelFontWeight(value: unknown): value is LabelFontWeight {
  return value === 'regular' || value === 'bold';
}

export function isLabelFontStyle(value: unknown): value is LabelFontStyle {
  return value === 'normal' || value === 'italic';
}
